<template>
    <ContentOrLoading>
        <MainContent v-if="grupo">
            <template v-slot:header>
                <PageTitle title="Detalles del grupo" />
            </template>
    
            <template v-slot:content>
                <b-tabs content-class="mt-3" v-model="activeTab">
                    <b-tab title="🔎 Detalles del grupo" active>
                        <b-card v-if="grupo" :loading="loading" class="mt-3">
                            <template #header>
                                <p class="mb-0"><strong>Nombre:</strong> {{ grupo.nombre }}</p>
                            </template>
                            <template #default>
                                <p class="mb-0"><strong>Descripción:</strong> {{ grupo.descripcion }}</p>
                            </template>
                        </b-card>
                    </b-tab>    
                    <b-tab title="👥 Listado de suscriptores" lazy>
                        <SubscriptoresListTab
                            v-if="grupo"
                            :grupo="grupo"
                            ref="subscriptoresTab"
                        />
                    </b-tab>    
                    <b-tab title="⬇️ Importar" lazy>
                        <GruposImportarTab
                            v-if="grupo"
                            :grupo="grupo"
                            @importacion-completada="onImportacionCompletada"
                        />
                    </b-tab>
                </b-tabs>
            </template>
        </MainContent>
    </ContentOrLoading>
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from '@/components/backend/components/MainContent';
    import PageTitle from '@/components/backend/components/PageTitleComponent';
    import SubscriptoresListTab from '@/components/backend/campana-emails/subscriptores/grupos/SubscriptoresListTab.vue';
    import GruposImportarTab from '@/components/backend/campana-emails/subscriptores/grupos/GruposImportarTab.vue';

    export default {
        data() {
            return {
                grupo: null,
                loading: false,
                activeTab: 0,
            }
        },
        methods: {
            async getGrupo() {
                this.loading = true;

                try {
                    const response = await apiService.getGrupo(this.grupo_id);
                    this.grupo = response.data;
                } catch (error) {
                    this.$toast.error('Error al cargar grupo:', error);
                } finally {
                    this.loading = false;
                }
            },

            onImportacionCompletada() {
                this.activeTab = 0;
            }
        },
        computed: {
            grupo_id() {
                return this.$route.params.grupo_id;
            }
        },
        created() {
            this.getGrupo();
        },
        components: {
            MainContent,
            PageTitle,
            SubscriptoresListTab,
            GruposImportarTab
        }
    }
</script>
